import React from 'react';
import {GrFormNext} from 'react-icons/gr';
import {useSwiper} from 'swiper/react';
import {Row, UiButton, UiImage, UiText} from '~/components/elements';

export const BackAndNextSlide = ({
  firstSlide,
  lastSlide,
  isActiveNextSlide,
  onNextSlide,
}: {
  firstSlide?: boolean;
  lastSlide?: boolean;
  isActiveNextSlide?: boolean;
  onNextSlide?: () => void;
}) => {
  const swiper = useSwiper();

  const handleGoBack = () => {
    swiper.slidePrev();
  };

  return (
    <Row justifyContent="space-between">
      {!firstSlide && (
        <Row justifyContent="flex-start" flex={1}>
          <UiButton
            onClick={handleGoBack}
            variant="nonFocus"
            style={{display: 'flex', alignItems: 'center'}}
            leftIcon={<UiImage type="icon" name="chevron-right" width={5} height={5} />}
            p={0}
          >
            <UiText
              style={{
                fontWeight: 600,
                fontSize: '14px',
                lineHeight: '24px',
                color: 'rgba(21, 25, 32, 0.5)',
              }}
            >
              Back
            </UiText>
          </UiButton>
        </Row>
      )}

      {isActiveNextSlide && !lastSlide && (
        <Row justifyContent="flex-end" style={{minWidth: '50px'}} flex={1}>
          <UiButton
            onClick={isActiveNextSlide ? onNextSlide : undefined}
            variant="nonFocus"
            style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}
            rightIcon={<GrFormNext size={20} opacity={isActiveNextSlide ? 1 : 0.4} />}
            p={0}
          >
            <UiText
              style={{
                fontWeight: 600,
                fontSize: '14px',
                lineHeight: '24px',
                color: isActiveNextSlide ? 'rgba(21, 25, 32, 1)' : 'rgba(21, 25, 32, 0.5)',
              }}
            >
              Next
            </UiText>
          </UiButton>
        </Row>
      )}
    </Row>
  );
};
